import { NavLink, useLocation } from "react-router-dom";
import SubRouter from "../../../router/subRouter";
import { CONFIGURATION_ROUTER_URL, FRESHMAN_ROUTER_URL } from "../../../constants/routerUrl";
import { ISubMenu } from "../../../models/common/ISubMenu";
import { connect } from "react-redux";
import { UserRole } from "../../../constants/RoleEnum";

const FreshmanSubMenu = (props: ISubMenu) => {
    const { currentRole } = props;
    const location = useLocation();

    const isActive = (path: string) => location.pathname.startsWith(path);

    return (
        <div className="admin-wrap">
            <div className="adminnav">
                {currentRole === UserRole.SuperAdmin && (
                    <ul>
                        <li>
                            <NavLink to={FRESHMAN_ROUTER_URL.FRESHMAN_CONFIGURATION_INDEX}>
                                Configuration
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={FRESHMAN_ROUTER_URL.FRESHMAN_MAINSTEP_INDEX}>
                                Main Task
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={FRESHMAN_ROUTER_URL.FRESHMAN_SUBSTEP_INDEX}>
                                Sub Task
                            </NavLink>
                        </li>
                    </ul>
                )}
            </div>
            <SubRouter />
        </div>
    );
};

function mapStateToProps(state: any) {
    return {
        currentRole: state.userDetails.userProfileData?.currentRole,
    };
}

export default connect(mapStateToProps, null)(FreshmanSubMenu);
